import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const FloatingConsultationButton = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleConsultationClick = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {/* Floating Button */}
      <div className="fixed bottom-6 left-6 z-40">
     
        {/* Status Indicator */}
        <div className="absolute -top-1 -right-1 w-3 h-3 bg-success rounded-full border-2 border-white animate-pulse" />
      </div>
      {/* Consultation Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-border">
              <h2 className="text-xl font-noto-arabic font-bold text-text-primary">
                حجز استشارة طبية
              </h2>
              <Button
                variant="ghost"
                size="icon"
                onClick={closeModal}
              >
                <Icon name="X" size={20} />
              </Button>
            </div>

            {/* Modal Content */}
            <div className="p-6 space-y-6">
              {/* Pharmacist Info */}
              <div className="flex items-center gap-4 p-4 bg-muted rounded-lg">
                <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center">
                  <Icon name="UserCheck" size={24} color="white" />
                </div>
                <div className="text-right">
                  <h3 className="font-cairo font-semibold text-text-primary">
                    د. أحمد محمد
                  </h3>
                  <p className="text-sm text-text-secondary">
                    صيدلي مرخص - 15 سنة خبرة
                  </p>
                  <div className="flex items-center gap-1 mt-1">
                    <span className="w-2 h-2 bg-success rounded-full" />
                    <span className="text-xs text-success font-medium">
                      متاح الآن
                    </span>
                  </div>
                </div>
              </div>

              {/* Available Time Slots */}
              <div>
                <h4 className="font-cairo font-semibold text-text-primary mb-3">
                  المواعيد المتاحة اليوم
                </h4>
                <div className="grid grid-cols-2 gap-2">
                  {['2:00 م', '3:30 م', '5:00 م', '7:30 م']?.map((time, index) => (
                    <Button
                      key={index}
                      variant="outline"
                      size="sm"
                      className="font-cairo hover:bg-primary hover:text-primary-foreground"
                    >
                      {time}
                    </Button>
                  ))}
                </div>
              </div>

              {/* Consultation Type */}
              <div>
                <h4 className="font-cairo font-semibold text-text-primary mb-3">
                  نوع الاستشارة
                </h4>
                <div className="space-y-2">
                  {[
                    { icon: 'Video', label: 'مكالمة فيديو', duration: '15 دقيقة' },
                    { icon: 'Phone', label: 'مكالمة صوتية', duration: '10 دقائق' },
                    { icon: 'MessageSquare', label: 'محادثة نصية', duration: '24 ساعة' }
                  ]?.map((type, index) => (
                    <button
                      key={index}
                      className="w-full flex items-center justify-between p-3 border border-border rounded-lg hover:border-primary hover:bg-muted transition-colors"
                    >
                      <div className="flex items-center gap-3">
                        <Icon name={type?.icon} size={20} className="text-primary" />
                        <div className="text-right">
                          <p className="font-cairo font-medium text-text-primary">
                            {type?.label}
                          </p>
                          <p className="text-sm text-text-secondary">
                            {type?.duration}
                          </p>
                        </div>
                      </div>
                      <div className="text-left">
                        <span className="font-bold text-accent">مجاني</span>
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="space-y-3 pt-4 border-t border-border">
                <Button
                  variant="default"
                  fullWidth
                  className="font-tajawal font-bold shadow-cta"
                >
                  احجز استشارتك المجانية
                </Button>
                <Button
                  variant="outline"
                  fullWidth
                  className="font-cairo"
                >
                  تصفح المنتجات أولاً
                </Button>
              </div>

              {/* Trust Badge */}
              <div className="text-center p-3 bg-success/10 rounded-lg">
                <div className="flex items-center justify-center gap-2 mb-1">
                  <Icon name="Shield" size={16} className="text-success" />
                  <span className="text-sm font-cairo font-medium text-success">
                    استشارة آمنة ومرخصة
                  </span>
                </div>
                <p className="text-xs text-text-secondary">
                  جميع الاستشارات تتم وفقاً لمعايير وزارة الصحة
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingConsultationButton;